<template>
  <div class="max-w-[720px] w-full px-4 sm:px-0 sm:mr-5">
    <h2 class="w-full text-center mb-8">
      {{ $t('messages.subscriptions.title') }}
    </h2>
    <div class="list--account flex flex-col border border-gray-200 rounded-lg sm:ml-10 bg-white">
      <div class="item--profile border-b border-gray-200 last:border-b-0">
        <div class="flex justify-between items-start">
          <h3 class="ml-6 mt-3 mb-3 b1">
            {{ $t('messages.subscriptions.description') }}
          </h3>
        </div>
        <div class="flex justify-between items-center mt-2 mb-2">
          <label
            class="text-gray-900 max-w-[360px] ml-6 mt-3 mb-3"
            for="marketingSubscription"
          >{{ $t('messages.subscriptions.marketing_subscription') }}</label>
          <label
            class="relative inline-flex items-center mt-3 mb-3 cursor-pointer"
            :class="{ 'cursor-not-allowed': isDemoAccount }"
          >
            <input
              id="marketingSubscription"
              v-model="marketingSubscription"
              type="checkbox"
              class="sr-only peer"
              :disabled="isDemoAccount"
            >
            <div
              class="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-zyxel-green-300 dark:peer-focus:ring-zyxel-green-500 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-zyxel-green-500 outline-none
                            "
            />
            <span class="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300" />
          </label>
        </div>
      </div>
    </div>
  </div>
  <Loading
    v-model:active="isLoading"
    color="#3C9F00"
    loader="spinner"
    background-color="#FFFFFF"
    :is-full-page="true"
  />
</template>
<script>
import { useAuthStore } from '@/stores/auth';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { logger } from '@/utils/logger';

export default {
    name: 'SetNotification',
    components: {
        Loading
    },
    data() {
        return {
            marketingSubscription: true,
            isLoading: false,
            initialLoad: true,
        }
    },
    computed: {
        isDemoAccount() {
            const authStore = useAuthStore();
            return authStore.isDemoAccount;
        }
    },
    watch: {
        marketingSubscription: 'updateSettings',
    },
    created() {
        this.fetchSettings();
    },
    methods: {
        async fetchSettings() {
            const authStore = useAuthStore();
            try {
                this.isLoading = true;
                const settings = await authStore.getSubscribeSettings();
                this.marketingSubscription = settings.subscribe_marketing_notification;
            } catch (error) {
                logger.error('Error fetching subscription settings:', error);
            } finally {
                this.isLoading = false;
                this.initialLoad = false;
            }
        },
        async updateSettings() {
            if (this.isLoading || this.isDemoAccount || this.initialLoad) return;
            this.isLoading = true;
            const authStore = useAuthStore();
            const updatedSettings = {
                subscribe_marketing_notification: this.marketingSubscription
            };

            try {
                await authStore.updateSubscribeSettings(updatedSettings);
            } catch (error) {
                logger.error('Error updating subscription settings:', error);
            } finally {
                this.isLoading = false;
            }
        }
    }
}
</script>
